module.exports = __webpack_public_path__ + "img/frasco_inovah_500.67ef6c63.png";